<template>
  <div class="hb-choose-school-list">
    <el-form class="form-wrapper">
      <el-form-item label="学校">
        <el-select
          v-model="local_filter_school"
          multiple
          collapse-tags
          placeholder="请选择(支持多选)"
        >
          <el-option
            v-for="item in kSchoolOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="教授名字">
        <el-input
          v-model="local_filter_doctor_name"
          placeholder="请输入项目关键词"
        ></el-input>
      </el-form-item>

      <el-form-item label="方向">
        <el-select v-model="local_filter_fangxiang" collapse-tags placeholder="请选择">
          <el-option v-for="item in filteroptions" :key="item.value" :label="item.value" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="教师职称">
        <el-select
          v-model="local_filter_professor_title"
          multiple
          collapse-tags
          placeholder="请选择(支持多选)"
        >
          <el-option
            v-for="item in kProfessorTitleOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="轮次">
        <el-select v-model="local_filter_rolling" collapse-tags placeholder="请选择">
          <el-option v-for="item in rollingOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型">
        <el-select
          v-model="local_filter_state"
          multiple
          collapse-tags
          placeholder="请选择(支持多选)"
        >
          <el-option
            v-for="item in kStateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="模板状态">-->
<!--        <el-select-->
<!--          v-model="local_filter_email_state"-->
<!--          multiple-->
<!--          collapse-tags-->
<!--          placeholder="请选择(支持多选)"-->
<!--        >-->
<!--          <el-option-->
<!--            v-for="item in kEmailStateOptions"-->
<!--            :key="item.value"-->
<!--            :label="item.label"-->
<!--            :value="item.value"-->
<!--          >-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <div style="display: flex; flex-direction: column; align-items: center">
        <el-button @click="filterAction" size="small" type="primary"
        >筛选</el-button
        >
      </div>
    </el-form>
<!--    <p style="margin-top: 20px !important">-->
<!--      <el-button @click="bindEmailEmpower" v-if="bindInfo.email_empower" size="mini" type="primary">已授权验证码</el-button>-->
<!--      <el-button @click="bindEmailEmpower" v-if="!bindInfo.email_empower"  size="mini" type="info">未授权验证码</el-button>-->
<!--    </p>-->
    <el-alert title="" type="error">
      <template slot="title">
        <p>套辞教授:{{count.tc_count+count.tc_s_count}}位，海套教授:{{count.tc_count}}位，深套教授:{{count.tc_s_count}}位</p>
      </template>
    </el-alert>
    <el-table
      :data="lists"
      style="width: 100%"
      :default-sort="{ prop: 'school_name', order: 'descending' }"
      v-loading="loading"
    >
      <el-table-column center property="" fixed="left" label="编号" width="80px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="teacher_name"
        label="教授名字"
        align="center"
        fixed="left"
        width="150"
      >
      </el-table-column>
      <el-table-column prop="school_name" label="学校" width="80" align="center" />
      <el-table-column prop="teacher_title" label="教授职称" align="center">
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content" style="line-height: 20px">{{scope.row.teacher_title}}</div>
            <span class="hidden_content">{{scope.row.teacher_title}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="方向" align="center"" >
  <template slot-scope=" scope">
  <div>{{ getDoctorDirTag(scope.row) }}</div>
  </template>
</el-table-column>
      <el-table-column prop="direction" label="研究" align="center">
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content" style="line-height: 20px">{{scope.row.direction}}</div>
            <span class="hidden_content">{{scope.row.direction}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="轮次" width="90" align="center">
  <template slot-scope="scope">
    <el-dropdown trigger="click" @command="(c) => handleCommand(scope.row, c)">
      <span class="el-dropdown-link">
        {{ scope.row.rolling || '未设置' }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="一轮套磁">一轮套磁</el-dropdown-item>
        <el-dropdown-item command="二轮套磁">二轮套磁</el-dropdown-item>
        <el-dropdown-item command="三轮套磁">三轮套磁</el-dropdown-item>
        <el-dropdown-item command="四轮套磁">四轮套磁</el-dropdown-item>
        <el-dropdown-item command="五轮套磁">五轮套磁</el-dropdown-item>
        <el-dropdown-item command="六轮套磁">六轮套磁</el-dropdown-item>
        <el-dropdown-item command="七轮套磁">七轮套磁</el-dropdown-item>
        <el-dropdown-item command="八轮套磁">八轮套磁</el-dropdown-item>
        <el-dropdown-item command="九轮套磁">九轮套磁</el-dropdown-item>
        <el-dropdown-item command="十轮套磁">十轮套磁</el-dropdown-item>

        <!-- <el-dropdown-item command="已回复-面邀">已回复-面邀</el-dropdown-item>
        <el-dropdown-item command="已回复-无面邀-补充材料">已回复-无面邀-补充材料</el-dropdown-item>
        <el-dropdown-item command="递交">递交</el-dropdown-item>
        <el-dropdown-item command="口头offer">口头offer</el-dropdown-item> -->

        <!-- <el-dropdown-item command="口头offer">口头offer</el-dropdown-item>
        <el-dropdown-item command="正式offer">正式offer</el-dropdown-item>
        <el-dropdown-item command="已拒绝">已拒绝</el-dropdown-item>
        <el-dropdown-item command="已回复-无面邀">已回复-无面邀</el-dropdown-item>
        <el-dropdown-item command="已回复-面邀">已回复-面邀</el-dropdown-item>
        <el-dropdown-item command="未回复">未回复</el-dropdown-item>
        <el-dropdown-item command="休假">休假</el-dropdown-item>
        <el-dropdown-item command="已退休">已退休</el-dropdown-item> -->
        <!-- <el-dropdown-item command="已拒绝">已拒绝</el-dropdown-item>
        <el-dropdown-item command="已回复-无面邀">已回复-无面邀</el-dropdown-item>
        <el-dropdown-item command="已回复-面邀">已回复-面邀</el-dropdown-item>
        <el-dropdown-item command="未回复">未回复</el-dropdown-item>
        <el-dropdown-item command="休假">休假</el-dropdown-item>
        <el-dropdown-item command="休假">已退休</el-dropdown-item> -->


      </el-dropdown-menu>
    </el-dropdown>
  </template>
</el-table-column>
      <!-- <el-table-column prop="email" label="邮箱" align="center" /> -->
      <el-table-column prop="personal_homepage" label="个人主页" align="center">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.personal_homepage">
            <el-link
              type="primary"
              :href="
                (scope.row.personal_homepage || '').includes('http')
                  ? scope.row.personal_homepage
                  : 'https://' + scope.row.personal_homepage
              "
              target="_blank"
            >查看</el-link
            >
          </el-tooltip>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="" label="面邀" align="center">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.interview_time && scope.row.interview_time"
            @click="showDetailInfoDialog(scope.row)"
            type="primary"
          >{{scope.row.interview_time}}</el-link
          >
          <p v-else>--</p>
        </template>
      </el-table-column> -->
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
<!--          <div v-if="scope.row.status == 1" type="primary" style="color: #08A0EEFF">博士海套</div>-->
<!--          <div v-else-if="scope.row.status == 2" type="primary" style="color: #08A0EEFF">博士深套</div>-->
<!--          <div v-else style="color: red">还未确定</div>-->
          <el-popconfirm title="是否改为海套？" class="btn" @confirm="editStatus(scope.row.id,1)" v-if="scope.row.status == 2">
            <el-button slot="reference" size="mini" type="primary" style="background: #f85d66">博士深套</el-button>
          </el-popconfirm>
          <el-popconfirm title="是否改为深套？" class="btn" @confirm="editStatus(scope.row.id,2)" v-if="scope.row.status == 1" >
            <el-button slot="reference" size="mini" type="primary" style="background: #124fe8">博士海套</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
<!--      <el-table-column label="模板状态" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          <div v-if="scope.row.status != 2 && scope.row.status != 1">-->
<!--            <div>&#45;&#45;</div>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <div v-if="scope.row.email_template_status == 1">未上传</div>-->
<!--            <div v-else-if="scope.row.email_template_status == 2" style="color: red">待确认</div>-->
<!--            <div v-else-if="scope.row.email_template_status == 3" style="color: red">驳回</div>-->
<!--            <div v-else-if="scope.row.email_template_status == 4" style="color: #08a0ee">同意</div>-->
<!--            <div v-else>未上传</div>-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->
<el-table-column label="套磁次数" width="80" prop="" align="center">
  <template slot-scope="scope">
    <el-link type="primary" @click="logEmail(scope.row)" v-if="scope.row.doctor_magnet_log">
      发送{{ scope.row.doctor_magnet_log.length }}次
    </el-link>
    <el-link type="primary" @click="logEmail(scope.row)" v-else>
      --
    </el-link>
  </template>
</el-table-column>
<el-table-column label="陶瓷备注">
  <template slot-scope="scope" with="90">
    <el-tooltip :content="scope.row.interview_content">
      <div>{{ scope.row.interview_content ? '查看' : '--' }}</div>
    </el-tooltip>
  </template>
</el-table-column>
      <el-table-column
        label="操作"
        prop=""
        align="center"
        fixed="right"
        width="120"
      >
        <template slot-scope="scope">
          <div class="btns-wrapper">
            <el-button class="btn" v-if="scope.row.status == 1" size="mini" @click="showEmailDialog(scope.row,'tc')" type="primary">海套邮箱模板</el-button>
            <el-button class="btn" v-if="scope.row.status == 2" size="mini" @click="showEmailDialog(scope.row,'tcs')" type="primary">深套邮箱模板</el-button>
<!--            <el-popconfirm title="是否确定为海套？" class="btn" @confirm="editStatus(scope.row.id,1)" v-if="scope.row.status == 0">-->
<!--              <el-button slot="reference" size="mini" type="primary">博士海套</el-button>-->
<!--            </el-popconfirm>-->
<!--            <el-popconfirm title="是否确定为深套？" class="btn" @confirm="editStatus(scope.row.id,2)" v-if="scope.row.status == 0">-->
<!--              <el-button slot="reference" size="mini" type="primary">博士深套</el-button>-->
<!--            </el-popconfirm>-->
            <el-popconfirm title="是否确定删除？" class="btn" @confirm="delUserDoctorMagnets(scope.row.id)">
              <el-button slot="reference" size="mini" type="danger" :loading="delLoading">删除</el-button>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <HBDoctorMagnetsEmail ref="doctor_magnets_email" @get_list="getList" />
    <el-dialog
      title="保存授权码"
      :visible.sync="openDialog"
      width="50%"
      center
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="top"
        ref="teacherFrom"
        size="small"
        label-width="120px"
        style="margin: 0"
      >
        <el-form-item label="旧授权码" v-if="bindInfo.email_empower">
          <p>{{bindInfo.email_empower }}</p>
        </el-form-item>
        <el-form-item label="授权码">
          <template slot="label">
            授权码
            <el-tooltip>
              <div @click="checkEmpowerHelpe" slot="content">
                查看填写说明？点我点我（老师可见）
              </div>
              <i class="el-icon-info" />
            </el-tooltip>
          </template>
          <el-input type="text" v-model="email_empower"></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button
            @click="openDialog = false"
            size="small"
            style="margin-right: 1rem"
          >取消</el-button
          >
          <el-button type="primary" size="small" @click="onSubmit()"
          >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      center
      title="查看"
      :visible="interviewDialog"
      width="50%"
      :before-close="() => (interviewDialog = false)"
    >
      <p style="white-space: pre-wrap; ">
        说明：{{ interview_content }}
      </p>
      <p style="white-space: pre-wrap; ">
        面试时间：{{ interview_time }}
      </p>
    </el-dialog>
  </div>
</template>
<script>
import {
  del_user_doctor_magnets,
  edit_user_doctor_magnets,
  get_user_doctor_magnets,
  email_empower_bind,
  setTaociRolling
} from "@/api/mycenter_studyabroad.js";
import HBDoctorMagnetsEmail from "../HBCommon/HBEmailDialog/HBEmailDialog.vue";

export default {
  name: "TabSecondTwo",
  components: {
    HBDoctorMagnetsEmail
  },
  props: ["flag"],
  data() {
    return {
      email_empower: '',
      openDialog: false,
      local_filter_school: [],
      local_filter_doctor_name: undefined,
      local_filter_professor_title: [],
      local_filter_state: [],
      local_filter_email_state: [],
      local_filter_rolling: [],
      local_filter_fangxiang: [],
      dataSource: [],
      count: {
        tc_count: 0,
        tc_s_count: 0
      },
      lists: [], // 数据列表
      delLoading: false,
      interview_content: null,
      interview_time: null,
      interviewDialog: false,
      requestData: {
        keywords: "", // 关键词
        page: 1, // 当前页
        paginate: 10000, // 分页大小
        templates_id: "",
        status: "",
        loading: "",
        user_id: "",
      },

    };
  },
  created() {
    this.$bus.on("abroad_tabs_changes", (newVal) => {
      if (newVal == this.flag) {
        this.getList(true);
      }
    });
    this.getList(true);
  },
  methods: {
    getDoctorDirTag(item) {
      const resultList = []
      item.doctor_tags.forEach((tag) => {
        if (tag.type == 0) {
          resultList.push(tag.name)
        }
      })
      return resultList.length > 0 ? resultList.join('|') : '-'
    },
    showDetailInfoDialog(_data){
      this.interviewDialog = true
      this.interview_content = _data.interview_content
      this.interview_time = _data.interview_time
    },
    bindEmailEmpower() {
      this.openDialog = true
    },
    onSubmit() {
      if (!this.email_empower) {
        this.$message.error('未填写授权码')
        return
      }
      email_empower_bind({ user_id: this.$route.query.userId,email_empower: this.email_empower }).then((response) => {
        this.$message.success('绑定成功')
        this.openDialog = false
        this.email_empower = ''
        this.$store.dispatch(
          'userAbroad/geUserAbroadData',
          parseInt(this.$route.query.userId)
        );
      })
    },
    showEmailDialog(_data,_type) {
      this.$refs.doctor_magnets_email.sendItem(_data, _type)
    },
    getList() {
      this.requestData.user_id = this.$route.query.userId;
      this.loading = true;
      get_user_doctor_magnets(this.requestData).then((response) => {
        this.loading = false;
        const dataList = response.data || [];
        this.dataSource = dataList.list
        this.lists = dataList.list
        this.count = dataList.count
        this.filterAction()
      });
    },
    editStatus(_id,_status){
      edit_user_doctor_magnets({ id: _id, status: _status })
        .then((response) => {
          this.$message.success('修改成功')
          this.getList(true);
        })
        .catch((error) => {
        });
    },
    filterAction() {
      if (
        (!this.local_filter_rolling || this.local_filter_rolling.length == 0) &&
        (!this.local_filter_fangxiang || this.local_filter_fangxiang.length == 0) && (!this.local_filter_school || this.local_filter_school.length == 0) &&

        (!this.local_filter_school || this.local_filter_school.length == 0) &&
        (!this.local_filter_professor_title || this.local_filter_professor_title.length == 0) &&
        !this.local_filter_doctor_name &&
        (!this.local_filter_state || this.local_filter_state.length == 0) &&
        (!this.local_filter_email_state || this.local_filter_email_state.length == 0)) {
        if (this.dataSource.length) {
          this.showSchoolNoticeDialog = false
        }
        this.lists = this.dataSource;
        return
      }
      const resultList = []
      const schoolList = this.local_filter_school || []
      const professorTitleList = this.local_filter_professor_title || []
      const stateList = this.local_filter_state || []
      const emailStateList = this.local_filter_email_state || []
      const doctor_name = this.local_filter_doctor_name;
      const fangxiagnlist = this.local_filter_fangxiang

      console.log(emailStateList)
      this.dataSource.forEach((item) => {
        var flag = true
        if (fangxiagnlist.length > 0) {
          var have = false
          const aaaa = fangxiagnlist
          item.doctor_tags.forEach(tagItem => {
            console.log(tagItem)
            if (aaaa == tagItem.name) {
              have = true
            }
          })
          if (have) {
            flag = true
          } else {
            flag = false
          }
        }
        if (schoolList.length > 0 && !schoolList.includes(item.school_name)) {
          flag = false
        }
        if (professorTitleList.length > 0 && !professorTitleList.includes(item.teacher_title)) {
          flag = false
        }
        if (stateList.length > 0 && !stateList.includes(item.status)) {
          flag = false
        }
        if (emailStateList.length > 0 && !emailStateList.includes(item.email_template_status)) {
          flag = false
        }
        if (this.local_filter_rolling.length > 0 && !this.local_filter_rolling.includes(item.rolling)) {
          console.log('进来了4')
          flag = false
        }
        if (
          doctor_name &&
          !item.teacher_name
            .toLocaleLowerCase()
            .includes(doctor_name.toLocaleLowerCase())
        ) {
          flag = false;
        }
        if (flag == true) {
          resultList.push(item)
        }
      })
      if (resultList.length) {
        this.showSchoolNoticeDialog = false
      } else {
        // this.getShowSchoolNotice()
      }
      this.lists = resultList
    },
    checkEmpowerHelpe() {
      window.open(
        "https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/admin_file/E823995081994177.pdf",
        "_blank"
      );
    },
    handleCommand(row, command) {
      console.log('选择了', command)
      row.rolling = command
      setTaociRolling({
        id: row.id,
        rolling: command
      }).then(res => {
        this.$message.success('设置成功')
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    delUserDoctorMagnets(id) {
      this.delLoading = true;
      del_user_doctor_magnets({ id: id })
        .then((response) => {
          this.getList(true);
          this.delLoading = false
        })
        .catch((error) => {
          this.delLoading = false
        });
    }
  },
  computed: {
    rollingOptions() {
      return [
      {
          label: "全部",
          value: null,
        },
        {
          label: "一轮套磁",
          value: "一轮套磁",
        },
        {
          label: "二轮套磁",
          value: "二轮套磁",
        },
        {
          label: "三轮套磁",
          value: "三轮套磁",
        },
        {
          label: "四轮套磁",
          value: "四轮套磁",
        },
        {
          label: "五轮套磁",
          value: "五轮套磁",
        },
        {
          label: "六轮套磁",
          value: "六轮套磁",
        },
        {
          label: "七轮套磁",
          value: "七轮套磁",
        },
        {
          label: "八轮套磁",
          value: "八轮套磁",
        },
        {
          label: "九轮套磁",
          value: "九轮套磁",
        },
        {
          label: "十轮套磁",
          value: "十轮套磁",
        },
        {
          label: "口头offer",
          value: "口头offer",
        },
        {
          label: "正式offer",
          value: "正式offer",
        },
        {
          label: "已拒绝",
          value: "已拒绝",
        },
        {
          label: "已回复-无面邀",
          value: "已回复-无面邀",
        },
        {
          label: "已回复-面邀",
          value: "已回复-面邀",
        },
        {
          label: "递交",
          value: "递交",
        },
        {
          label: "未回复",
          value: "未回复",
        },
        {
          label: "休假",
          value: "休假",
        },
        {
          label: "已退休",
          value: "已退休",
        },
        {
          label: "已回复-可做supervisor",
          value: "已回复-可做supervisor",
        },
        {
          label: "未回复-需要递交",
          value: "未回复-需要递交",
        },
        {
          label: "已回复-无面邀-补充材料",
          value: "已回复-无面邀-补充材料",
        },
        {
          label: "已回复-无面邀-建议递交",
          value: "已回复-无面邀-建议递交",
        },
        // <!-- <el-dropdown-item command="已回复-面邀">已回复-面邀</el-dropdown-item>
        // <el-dropdown-item command="已回复-无面邀-补充材料">已回复-无面邀-补充材料</el-dropdown-item>
        // <el-dropdown-item command="递交">递交</el-dropdown-item>
        // <el-dropdown-item command="口头offer">口头offer</el-dropdown-item> -->
       

      ];
    },
    bindInfo() {
      return this.$store.state.userAbroad.userAbroadData;
    },
    filteroptions() {
      if (this.dataSource && this.dataSource.length > 0) {
        const resultsList = []
        this.dataSource.forEach(item => {
          item.doctor_tags.forEach((tag) => {
            if (tag.type == 0) {
              const haveIndex = resultsList.findIndex(fasdf => {
                return fasdf.text == tag.name
              })
              if (haveIndex < 0) {
                resultsList.push({
                  text: tag.name,
                  value: tag.name
                })
              }

            }
          })

        })
        // console.log("resultsList", resultsList)
        return resultsList
      } else {
        return []
      }
    },
    kSchoolOptions() {
      if (this.dataSource && this.dataSource.length > 0) {
        const l = [];
        this.dataSource.forEach((item) => {
          const index = l.findIndex(
            (subItme) => subItme.label == item.school_name
          );
          if (index < 0) {
            if (item && item.school_name) {
              l.push({
                label: item.school_name,
                value: item.school_name
              })
            }
          }
        });
        return l;
      } else {
        return [];
      }
    },
    kProfessorTitleOptions() {
      if (this.dataSource && this.dataSource.length > 0) {
        const l = [];
        this.dataSource.forEach((item) => {
          const index = l.findIndex(
            (subItme) => subItme.label == item.teacher_title
          )
          if (index < 0) {
            if (item && item.teacher_title) {
              l.push({
                label: item.teacher_title,
                value: item.teacher_title
              })
            }
          }
        })
        return l;
      } else {
        return [];
      }
    },
    kEmailStateOptions() {
      return [
        {
          label: "待确认",
          value: 2,
        },
        {
          label: "驳回",
          value: 3,
        },
        {
          label: "同意",
          value: 4,
        },
      ];
    },
    kStateOptions() {
      return [
        {
          label: "未选择",
          value: 0,
        },
        {
          label: "博士海套",
          value: 1,
        },
        {
          label: "博士深套",
          value: 2,
        },
      ];
    }
  },
};
</script>
<style scoped lang="scss">
.hidden_content{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 显示行数 */
  overflow: hidden;
  white-space: normal;
}
.form-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  .el-form-item {
    margin-bottom: 0 !important;
  }
}
.hb-choose-school-list {
  .max-two-line {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .btns-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    .btn {
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_second_two.vue